import { STRICT_WS, STRICT_WS_SUCCESS, STRICT_WS_ERROR } from './actionTypes';

const initialState = {
    errorStrictWs: "",
    loadingStrictWs: false,
    successStrictWs: ""
}

const strictWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case STRICT_WS:
            state = {
                ...state,
                loadingStrictWs: true
            }
            break;
        case STRICT_WS_SUCCESS:
            state = {
                ...state,
                loadingStrictWs: false,
                successStrictWs: action.payload.message
            }
            break;
        case STRICT_WS_ERROR:
            state = { ...state, errorStrictWs: action.payload, loadingStrictWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default strictWorkstations;